import React, { useRef } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from 'ckeditor5-build-classic-full-option';
import './styles.scss';

function customItemRenderer(item) {
    return item.text.replace('[[', '').replace(']]', '');
}

export default function CKEditorInputComponent(props) {

    const {label, data, onChange, disabled, feeds} = props;

    const reflbl = useRef();
    const refcls = useRef();

    return <div className="ck-editor-input" ref={refcls}>
    <span ref={reflbl} className="ck-editor-input-title">{label}</span>
    <CKEditor
        editor={ClassicEditor}
        data={data}
        disabled={disabled === 1 ? true : false}
        onChange={(event, editor) => {
            const value = editor.getData();
            onChange(value);
        }}
        config={{
            mention: {
                feeds: [
                    {
                        marker: '[',
                        feed: feeds,
                        itemRenderer: customItemRenderer,

                    }
                ]
            },
        }}
        onFocus={(e) => {
            reflbl.current.classList.add('lbl-focus');
            refcls.current.classList.add('cls-focus');

        }}
        onBlur={(e) => {
            reflbl.current.classList.remove('lbl-focus');
            refcls.current.classList.remove('cls-focus');
        }}
    />
</div>
}